import { useSelector } from "react-redux"
import BlockingScreenLayer from "../../common/containers/BlockingScreenLayer";
import { FULLY_BLOCKING_POPUP_ZINDEX as zIndex } from "../../../utils/constants/otherConstants";
import PopupPaper from "../PopupPaper";
import { Divider } from "@mui/material";
import { getUserSettings, isSettingsWindowVisible } from "../../../reducers/userSettings";
import { FormProvider } from "../../../contexts/FormContext";
import SettingsFormBody from "./SettingsFormBody";
import { useViewport } from "../../../hooks/others/useViewport";
import SettingsFormFooter from "./SettingsFormFooter";
import SettingsFormHeader from "./SettingsFormHeader";
import { SETTINGS_WINDOW_HEIGHT, SETTINGS_WINDOW_PADDING, SETTINGS_WINDOW_WIDTH } from "../../../utils/constants/viewConstants";

const SettingsWindow = () => {
    const visible = useSelector(isSettingsWindowVisible);
    const userSettings = useSelector(getUserSettings);

    const width = useViewport(SETTINGS_WINDOW_WIDTH);
    const height = SETTINGS_WINDOW_HEIGHT;
    const padding = SETTINGS_WINDOW_PADDING;

    return (
        <>
        {
            visible &&
            <BlockingScreenLayer zIndex={zIndex}>
                <div className="full-width full-height d-flex flex-row jc-center ai-center">
                    <PopupPaper style={{width, height, padding}}>
                        <div className="d-flex flex-column gap-1 full-width full-height">
                            <FormProvider initialData={userSettings}>
                                <SettingsFormHeader />
                                <Divider />
                                <SettingsFormBody />
                                <Divider />
                                <SettingsFormFooter />
                            </FormProvider>
                        </div>
                    </PopupPaper>
                </div>
            </BlockingScreenLayer>
        }
        </>
    )
}

export default SettingsWindow;